<template>
  <div class="row bg-white w-100-per ml-0 min-height-100vh">
    <div class="col-lg-7 pr-0 pl-0 min-height-100vh pad-100-b registration-bg">
      <div class="row pad-15-t push-10-l push-10-r">
        <div class="col-xs-6 push-5-t min-height-70">
          <a href="https://www.advicepay.com">
            <img class="min-height-70" src="/assets/img/advicepay-primary-logo-evergreen-rgb.svg" width="325">
          </a>
        </div>

        <div v-if="currentUser" class="col-xs-6 text-right push-10-t">
          <SwitchAccountDropdown class="inline-block" :currentUser="currentUser" :accessibleUsers="accessibleUsers" />
          <a href="/logoff" class="push-15-l">Log Out</a>
        </div>
      </div>

      <div class="row push-10-r text-right hidden-lg" v-if="currentUser">
        <div class="col-xs-12">
          <em class="text-muted fs-12 dis-block">Selected Plan</em>
          <a href="#" @click.prevent="panelHidden = false">{{ $filters.capitalize(plan) }}</a>
        </div>
      </div>

      <div class="col-xs-11 col-md-10 col-sm-8 col-lg-9 col-centered side-column-always-show-wide" :class="{ 'hidden': !panelHidden }">
        <slot name="content"></slot>
      </div>
    </div>
    <div class="col-xs-12 col-lg-5 text-center pad-30-b side-column-always-show-wide side-column-hide-narrow min-height-100vh registration-plan-offering-container" :class="{ 'hidden': panelHidden }">
      <div class="col-xs-11 col-sm-8 col-md-6 col-lg-10 col-centered text-left push-20 hidden-lg">
        <a href="#" @click.prevent="panelHidden = true" class="text-white"><i class="fa fa-arrow-left push-5-r" /> Go Back</a>
      </div>

      <div class="col-xs-11 col-sm-8 col-md-6 col-lg-10 col-centered">
        <div v-if="!changingPlan">
          <RefreshPlanOffering class="bg-white pad-20" :plan="internalPlan" :currentUser="currentUser" :coupon="coupon" />
          <a href="#" v-if="currentUser && !planIsSelfPayRep" @click.prevent="changingPlan = true" class="text-black inline-block push-15-t">Change subscription plan</a>
        </div>

        <div v-if="changingPlan">
          <RadioTile v-model="internalPlan" :inputVal="accountTypes.ESSENTIAL" class="bg-white push-10-t flex-row-start pad-15">
            <div class="flex-row push-15-l">
              <img src="/assets/img/individual.svg" class="push-10-r" />
              <div class="fw-600">Essential</div>
            </div>

            <div class="flex-row-start-right-item">
              <em class="text-muted fs-12 dis-block">Starting from</em>
              <strong class="inline-block">${{ planData(accountTypes.ESSENTIAL).cost }}.00</strong><span class="h5 text-muted">/mth</span>
            </div>
          </RadioTile>

          <RadioTile v-model="internalPlan" :inputVal="accountTypes.PROFESSIONAL" class="bg-white push-10-t flex-row-start pad-15">
            <div class="flex-row push-15-l">
              <img src="/assets/img/professional.svg" class="push-10-r" />
              <div class="fw-600">Professional</div>
            </div>

            <div class="flex-row-start-right-item">
              <em class="text-muted fs-12 dis-block">Starting from</em>
              <strong class="inline-block">${{ planData(accountTypes.PROFESSIONAL).cost }}.00</strong><span class="h5 text-muted">/mth</span>
            </div>
          </RadioTile>

          <RadioTile v-model="internalPlan" :inputVal="accountTypes.ENTERPRISE" class="bg-white push-10-t flex-row-start pad-15">
            <div class="flex-row push-15-l">
              <img src="/assets/img/enterprise.svg" class="push-10-r" />
              <div class="fw-600">Enterprise</div>
            </div>

            <div class="flex-row-start-right-item">
              <strong class="dis-block">Let's Talk</strong>
              <em class="h6 text-muted">Contact Sales for Custom Pricing</em>
            </div>
          </RadioTile>

          <button @click.prevent="updatePlan" v-if="differentPlanSelected" class="btn btn-primary btn-block btn-md push-15-t">Update Subscription</button>
          <a href="#" @click.prevent="cancelPlanChange" class="text-white inline-block push-15-t">Cancel</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Watch, Emit, Vue } from 'vue-facing-decorator'; 
import UserTypes from '../../../types/users';
import SwitchAccountDropdown from '../../layout/shared/SwitchAccountDropdown.vue';
import RefreshPlanOffering from './RefreshPlanOffering.vue';
import RadioTile from '../../shared/RadioTile.vue';
import UserConstants from '../../../constants/users';
import PlanConstants from '../../../constants/plans';
import RegistrationAPI from '../../../api/modules/registration';
import TransactionFees from './TransactionFees.vue';

@Component({
  components: {
    SwitchAccountDropdown,
    RefreshPlanOffering,
    RadioTile,
    TransactionFees
  }
})
export default class Container extends Vue {
  @Prop({ type: String, required: true }) plan!: string;
  @Prop({ type: Object }) currentUser!: UserTypes.User;
  @Prop({ type: Array }) accessibleUsers!: Array<UserTypes.User>;
  @Prop({ type: String }) coupon!: string;

  accountTypes = UserConstants.accountTypes;

  panelHidden = true
  changingPlan = false
  internalPlan = ''

  @Emit()
  changed(): string {
    return this.internalPlan;
  }

  @Watch('plan')
  onValueChanged(newValue: string) {
    this.internalPlan = newValue;
  }

  created() {
    this.internalPlan = this.plan;
  }

  cancelPlanChange() {
    this.changingPlan = false;
    this.internalPlan = this.plan;
  }
  planData(k: string): any {
    return PlanConstants.plans.TYPES.find((el: { key: string }) => { return el.key == k });
  }
  updatePlan() {
    if (!this.differentPlanSelected || this.planIsSelfPayRep) { return; }

    RegistrationAPI.accountType({ accountType: this.internalPlan }).then(
      () => {
        window.App.loader('hide');
        this.changingPlan = false;
        this.changed();
        window.$.notify({ message: "Your subscription has been updated" }, { type: "success" });
      },
      () => { this.genericError(); }
    )
  }

  get differentPlanSelected(): boolean {
    return this.internalPlan != this.plan;
  }
  get planIsSelfPayRep(): boolean {
    return this.internalPlan == this.accountTypes.ENTERPRISE_SELF_PAY_REP;
  }
}
</script>
